import React from "react";
import Faculty from "@/pages/Faculty";
import LeadMagnet from "@/components/LeadMagnet";
import useMeta from "@/hooks/useMeta";

const VIETNAM_GROUP = "/about/vietnam-group-upright.webp";
const VIETNAM_PODIUM = "/api/static/assets/0f6819df_gjy4yxbr_000018345608.jpg";

const About = () => {
  useMeta({
    title: "About Dr. Andrew H. Campbell — Global Leader Solutions",
    description: "Meet the founder of Global Leader Solutions — 25+ years of military, diplomatic, and academic leadership experience. Founder of GLETI. TEDx speaker.",
    canonical: "https://globalleadersolutions.com/about",
  });
  return (
  <div>
    <Faculty />

    {/* Global Reach */}
    <section className="bg-[#FAF4F5] border-y border-[#E8DCDD]" data-testid="global-reach-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl mb-12">
          <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57] mb-3">Global Reach</div>
          <h2 className="text-3xl sm:text-4xl font-serif font-semibold text-[#2D2628] leading-tight mb-4">
            Leadership development across borders and cultures.
          </h2>
          <p className="text-base text-[#6B5E62] leading-relaxed">
            Dr. Campbell has contributed to leadership research and practice on the international stage —
            including the 2019 Vietnam Symposium on Leadership and Public Policy in Ho Chi Minh City,
            where he represented the International Peace and Leadership Institute.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <img src={VIETNAM_GROUP} alt="Vietnam Symposium on Leadership and Public Policy — Ho Chi Minh City 2019"
            data-testid="global-reach-photo-1"
            className="w-full h-auto rounded-md shadow-md object-cover aspect-[4/3]" />
          <img src={VIETNAM_PODIUM} alt="Dr. Campbell speaking at the Vietnam Symposium 2019"
            data-testid="global-reach-photo-2"
            className="w-full h-auto rounded-md shadow-md object-cover aspect-[4/3]" />
        </div>
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#8C4A57] text-center mt-6">
          Vietnam Symposium on Leadership and Public Policy · 28–29 October 2019 · Ho Chi Minh City
        </div>
      </div>
    </section>

    <LeadMagnet />
  </div>
  );
};

export default About;
